import { BehaviorSubject } from 'rxjs';

export default class EmailChangeRepository {
  mfaNumber$ = new BehaviorSubject('');
  stepIndex$ = new BehaviorSubject(0);

  dispose() {
    this.mfaNumber$.next('');
    this.stepIndex$.next(0);
  }
}
